// extracted by mini-css-extract-plugin
export default {"divButton":"button_divButton__nBWMw"};